var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPluscircleblueline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 1.5C7.74566 1.5 5.58365 2.39553 3.98959 3.98959C2.39553 5.58365 1.5 7.74566 1.5 10C1.5 12.2543 2.39553 14.4163 3.98959 16.0104C5.58365 17.6045 7.74566 18.5 10 18.5C12.2543 18.5 14.4163 17.6045 16.0104 16.0104C17.6045 14.4163 18.5 12.2543 18.5 10C18.5 7.74566 17.6045 5.58365 16.0104 3.98959C14.4163 2.39553 12.2543 1.5 10 1.5Z",
    fill: "#0082B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58402 14.9277C9.69435 15.038 9.84398 15.1 10 15.1C10.156 15.1 10.3057 15.038 10.416 14.9277C10.5263 14.8174 10.5883 14.6677 10.5883 14.5117V5.48828C10.5883 5.33226 10.5263 5.18263 10.416 5.0723C10.3057 4.96198 10.156 4.9 10 4.9C9.84398 4.9 9.69435 4.96198 9.58402 5.0723C9.4737 5.18263 9.41172 5.33226 9.41172 5.48828V14.5117C9.41172 14.6677 9.4737 14.8174 9.58402 14.9277Z",
    fill: "#0082B6",
    stroke: "#0082B6",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9277 9.58402L14.8572 9.65453L14.9277 9.58402C14.8174 9.4737 14.6677 9.41172 14.5117 9.41172H5.48828C5.33226 9.41172 5.18263 9.4737 5.0723 9.58402C4.96198 9.69435 4.9 9.84398 4.9 10C4.9 10.156 4.96198 10.3057 5.0723 10.416C5.18263 10.5263 5.33226 10.5883 5.48828 10.5883H14.5117C14.6677 10.5883 14.8174 10.5263 14.9277 10.416C15.038 10.3057 15.1 10.156 15.1 10C15.1 9.84398 15.038 9.69435 14.9277 9.58402Z",
    fill: "#0082B6",
    stroke: "#0082B6",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluscircleblueline);
export default __webpack_public_path__ + "static/media/pluscircleblueline.4ac180577171ee897e26ed4b50b98562.svg";
export { ForwardRef as ReactComponent };